import AdManagement from './adManagement'
const globalEnumPermData = {
    语言类型: {
        en: "英语",
        pt: "葡萄牙语",
        es: "西班牙语",
    },
    热门游戏_类别: {
        子游戏: false,
        平台: true,
    },
    权限枚举值: {
        ...AdManagement,
        数据看板: `merchantDashboardManage`,
        数据看板__页面查看: `merchantDashboardManageDashboardQueryPerm`,
        会员管理: `merchantMemberManage`,
        会员管理__会员列表: `merchantMemberManageMemberList`,
        会员管理__会员列表__页面查看: `merchantMemberManageMemberListQueryPerm`,
        会员管理__会员列表__导出: `merchantMemberManageMemberListExportPerm`,
        会员管理__会员详情: `merchantMemberManageMemberDetail`,
        会员管理__会员详情__基础信息: `merchantMemberManageMemberDetailBasic`,
        会员管理__会员详情__基础信息__页签查看: `merchantMemberManageMemberDetailBasicQueryPerm`,
        会员管理__会员详情__基础信息__会员分层: `merchantMemberManageMemberDetailBasicLevelPerm`,
        会员管理__会员详情__基础信息__会员状态: `merchantMemberManageMemberDetailBasicStatusPerm`,
        会员管理__会员详情__基础信息__编辑资料: `merchantMemberManageMemberDetailBasicInfoPerm`,
        会员管理__会员详情__基础信息__修改登录密码: `merchantMemberManageMemberDetailBasicLoginPassPerm`,
        会员管理__会员详情__基础信息__修改保险箱密码: `merchantMemberManageMemberDetailBasicSafePassPerm`,
        会员管理__会员详情__基础信息__重置支付密码: `merchantMemberManageMemberDetailBasicPayPassPerm`,
        会员管理__会员详情__基础信息__新增备注: `merchantMemberManageMemberDetailBasicRemarkPerm`,
        会员管理__会员详情__账户信息: `merchantMemberManageMemberDetailAccount`,
        会员管理__会员详情__账户信息__页签查看: `merchantMemberManageMemberDetailAccountQueryPerm`,
        会员管理__会员详情__账户信息__场馆回收: `merchantMemberManageMemberDetailAccountTransferInPerm`, // ?
        会员管理__会员详情__账户信息__保险箱回收: `merchantMemberManageMemberDetailAccountTransferOutPerm`, //?
        会员管理__会员详情__财务信息: `merchantMemberManageMemberDetailFinance`,
        会员管理__会员详情__财务信息__页签查看: `merchantMemberManageMemberDetailFinanceQueryPerm`,
        会员管理__会员详情__卡号信息: `merchantMemberManageMemberDetailCard`,
        会员管理__会员详情__卡号信息__页签查看: `merchantMemberManageMemberDetailCardQueryPerm`,
        会员管理__会员详情__卡号信息__删除: `merchantMemberManageMemberDetailCardDeletePerm`,
        会员管理__现金系统: `merchantMemberManageCash`,
        会员管理__现金系统__页面查看: `merchantMemberManageCashQueryPerm`,
        会员管理__现金系统__导出: `merchantMemberManageCashExportPerm`,
        会员管理__会员层级: `merchantMemberManageLevel`,
        会员管理__会员层级__页面查看: `merchantMemberManageLevelQueryPerm`,
        会员管理__会员层级__添加层级: `merchantMemberManageLevelAddPerm`,
        会员管理__会员层级__编辑: `merchantMemberManageLevelEditPerm`,
        会员管理__会员层级__状态开关: `merchantMemberManageLevelEditPerm`,
        会员管理__VIP等级设置: `merchantMemberManageVip`,
        会员管理__VIP等级设置__页面查看: `merchantMemberManageVipQueryPerm`,
        会员管理__VIP等级设置__编辑: `merchantMemberManageVipEditPerm`,
        会员管理__VIP等级设置__新增VIP等级: `merchantMemberManageVipAddPerm`,
        会员管理__异常流水: `merchantMemberManageAbnormal`,
        会员管理__异常流水__页面查看: `merchantMemberManageAbnormalQueryPerm`,
        会员管理__异常流水__强制回收: `merchantMemberManageAbnormalRecyclePerm`,
        会员管理__会员标签: `merchantMemberManageLabel`,
        会员管理__会员标签__新增数据: `merchantMemberManageLabelAddPerm`,
        会员管理__会员标签__修改数据: `merchantMemberManageLabelEditPerm`,
        会员管理__会员标签__删除数据: `merchantMemberManageLabelDeletePerm`,
        游戏管理: `merchantGameManage`,
        游戏管理__游戏注单: `merchantGameManageOrder`,
        游戏管理__游戏注单__游戏注单: `merchantGameManageOrder`,
        游戏管理__游戏注单__游戏注单__页面查看: `merchantGameManageOrderQueryPerm`,
        // 游戏管理__游戏注单__人工拉取: `gameOrderListPullTab`,
        // 游戏管理__游戏注单__人工拉取__页面查看: `gameOrderListPullQueryPerms`,
        // 游戏管理__游戏注单__人工拉取__人工拉取注单: `gameOrderListPullPerms`,
        游戏管理__游戏管理: `merchantGameManageGameTab`,
        游戏管理__游戏管理__分类设置: `merchantGameManageGameTabCategory`,
        游戏管理__游戏管理__分类设置__页签查看: `merchantGameManageGameTabCategoryQueryPerm`,
        游戏管理__游戏管理__分类设置__编辑: `merchantGameManageGameTabCategoryEditPerm`,
        游戏管理__游戏管理__分类设置__状态开关: `merchantGameManageGameTabCategoryStatusPerm`,
        游戏管理__游戏管理__平台管理: `merchantGameManageGameTabPlatform`,
        游戏管理__游戏管理__平台管理__页签查看: `merchantGameManageGameTabPlatformQueryPerm`,
        游戏管理__游戏管理__平台管理__编辑: `merchantGameManageGameTabPlatformEditPerm`,
        游戏管理__游戏管理__平台管理__维护开关: `merchantGameManageGameTabPlatformStatusPerm`,
        // 游戏管理__游戏管理__平台管理__热门开关: `gamePlatformHotPerms`, // ？
        游戏管理__游戏管理__平台管理__状态开关: `merchantGameManageGameTabPlatformStatusPerm`,
        游戏管理__游戏管理__子游戏管理: `merchantGameManageGameTabSubGame`,
        游戏管理__游戏管理__子游戏管理__页签查看: `merchantGameManageGameTabSubGameQueryPerm`,
        游戏管理__游戏管理__子游戏管理__添加: `merchantGameManageGameTabSubGameAddPerm`,
        游戏管理__游戏管理__子游戏管理__编辑: `merchantGameManageGameTabSubGameEditPerm`,
        游戏管理__游戏管理__子游戏管理__维护开关: `merchantGameManageGameTabSubGameStatusPerm`,
        游戏管理__游戏管理__子游戏管理__热门开关: `merchantGameManageGameTabSubGameStatusPerm`,
        游戏管理__游戏管理__子游戏管理__启用禁用: `merchantGameManageGameTabSubGameStatusPerm`,
        游戏管理__游戏管理__热门游戏: `merchantGameManageGameTabHot`,
        游戏管理__游戏管理__热门游戏__页签查看: `merchantGameManageGameTabHotQueryPerm`,
        游戏管理__游戏管理__热门游戏__编辑: `merchantGameManageGameTabHotEditPerm`,
        游戏管理__游戏管理__热门游戏__移除: `merchantGameManageGameTabHotDeletePerm`,
        游戏管理__游戏管理__类型管理: "merchantGameManageGameTabCategory",
        // 未使用
        游戏管理__游戏管理__类型管理__页签查看: "merchantGameManageGameTabCategoryQueryPerm",
        游戏管理__游戏管理__类型管理__编辑: "merchantGameManageGameTabCategoryEditPerm",
        游戏管理__游戏管理__类型管理__状态开关: "merchantGameManageGameTabCategoryStatusPerm",
        运营管理: `merchantOperationManage`,
        运营管理__Banner管理: `merchantOperationManageBanner`,
        运营管理__Banner管理__页面查看: `merchantOperationManageBannerQueryPerm`,
        运营管理__Banner管理__新增数据: `merchantOperationManageBannerAddPerm`,
        运营管理__Banner管理__修改数据: `merchantOperationManageBannerEditPerm`,
        运营管理__Banner管理__状态开关: `merchantOperationManageBannerStatusPerm`,
        运营管理__Banner管理__批量删除: `merchantOperationManageBannerDeletePerm`,
        运营管理__轮播管理: `merchantOperationManageBanner`,
        运营管理__轮播管理__页面查看: `merchantOperationManageBannerQueryPerm`,
        运营管理__轮播管理__添加轮播图片: `merchantOperationManageBannerAddPerm`,
        运营管理__轮播管理__编辑: `merchantOperationManageBannerEditPerm`,
        运营管理__轮播管理__状态开关: `merchantOperationManageBannerStatusPerm`,
        运营管理__轮播管理__批量删除: `merchantOperationManageBannerDeletePerm`,
        运营管理__消息管理: `merchantOperationManageMessageTab`,
        运营管理__消息管理__系统公告: `merchantOperationManageMessageTabAnnouncement`,
        运营管理__消息管理__系统公告__页签查看: `merchantOperationManageMessageTabAnnouncementQueryPerm`,
        运营管理__消息管理__系统公告__发布公告: `merchantOperationManageMessageTabAnnouncementAddPerm`,
        运营管理__消息管理__系统公告__置顶: `merchantOperationManageMessageTabAnnouncementAddPerm`,
        运营管理__消息管理__系统公告__状态开关: `merchantOperationManageMessageTabAnnouncementStatusPerm`,
        运营管理__消息管理__系统公告__编辑: `merchantOperationManageMessageTabAnnouncementEditPerm`,
        运营管理__消息管理__系统公告__删除: `merchantOperationManageMessageTabAnnouncementDeletePerm`,
        运营管理__消息管理__系统公告__批量删除: `merchantOperationManageMessageTabAnnouncementDeletePerm`,
        运营管理__消息管理__站内消息: `merchantOperationManageMessageTabNotification`,
        运营管理__消息管理__站内消息__页签查看: `merchantOperationManageMessageTabNotificationQueryPerm`,
        运营管理__消息管理__站内消息__发布站内信息: `merchantOperationManageMessageTabNotificationAddPerm`,
        运营管理__消息管理__站内消息__编辑: `merchantOperationManageMessageTabNotificationEditPerm`,
        运营管理__消息管理__站内消息__删除: `merchantOperationManageMessageTabNotificationDeletePerm`,
        运营管理__消息管理__游戏公告: `merchantOperationManageMessageTabGameAnnouncement`,
        运营管理__消息管理__游戏公告__页签查看: `merchantOperationManageMessageTabGameAnnouncementQueryPerm`,
        运营管理__消息管理__游戏公告__发布游戏公告: `merchantOperationManageMessageTabGameAnnouncementAddPerm`,
        运营管理__消息管理__游戏公告__编辑: `merchantOperationManageMessageTabGameAnnouncementEditPerm`,
        运营管理__消息管理__游戏公告__删除: `merchantOperationManageMessageTabGameAnnouncementDeletePerm`,
        // 大改？
        运营管理__站点配置: `merchantOperationManageSiteTab`,
        运营管理__站点配置__网站信息: `webConfigTab`,
        运营管理__站点配置__网站信息__页签查看: `webConfigQueryPerms`,
        运营管理__站点配置__网站信息__保存: `webConfigAddPerms`,
        运营管理__站点配置__网站信息__上传包: `appUploadPerms`,
        运营管理__站点配置__网站信息__下载包: `appDownloadPerms`,
        运营管理__站点配置__注册设置: `registerTab`,
        运营管理__站点配置__注册设置__页签查看: `registerQueryPerms`,
        运营管理__站点配置__注册设置__保存: `registerEditPerms`,
        运营管理__站点配置__登录设置: `loginTab`,
        运营管理__站点配置__登录设置__页签查看: `loginQueryPerms`,
        运营管理__站点配置__登录设置__保存: `loginEditPerms`,
        运营管理__站点配置__基础配置: `merchantOperationManageSiteTabBasic`,
        运营管理__站点配置__基础配置_页面查看: `merchantOperationManageSiteTabBasicQueryPerm`,
        运营管理__站点配置__基础配置_修改数据: `merchantOperationManageSiteTabBasicEditPerm`,
        运营管理__站点配置__资源配置: `merchantOperationManageSiteTabResource`,
        运营管理__站点配置__资源配置_页面查看: `merchantOperationManageSiteTabResourceQueryPerm`,
        运营管理__站点配置__资源配置_修改数据: `merchantOperationManageSiteTabResourceEditPerm`,
        运营管理__站点配置__关于我们: `merchantOperationManageSiteTabAboutUs`,
        运营管理__站点配置__关于我们_页面查看: `merchantOperationManageSiteTabAboutUsQueryPerm`,
        运营管理__站点配置__关于我们_修改数据: `merchantOperationManageSiteTabAboutUsEditPerm`,
        // 运营管理__站点配置__基础资源配置: `basicResourceTab`,
        // 运营管理__站点配置__基础资源配置__保存: `basicResourceEditPerms`,
        //
        // 运营管理__站点配置__APP包管理: `appPackageTab`,
        // 运营管理__站点配置__APP包管理__保存: `appPackageEditPerms`,

        运营管理__站点配置__汇率设置: `exchangeRateTab`,
        运营管理__站点配置__汇率设置__页签查看: `exchangeRateQueryPerms`,
        运营管理__站点配置__汇率设置__保存: `exchangeRateEditPerms`,
        运营管理__站点配置__绑卡提现配置: `withdrawCardTab`,
        运营管理__站点配置__绑卡提现配置__页签查看: `withdrawCardQueryPerms`,
        运营管理__站点配置__绑卡提现配置__保存: `withdrawCardEditPerms`,
        运营管理__站点配置__客服设置: `customerServiceTab`,
        运营管理__站点配置__客服设置__页签查看: `customerServiceQueryPerms`,
        运营管理__站点配置__客服设置__保存: `customerServiceEditPerms`,
        运营管理__站点配置__常见问题: `questionTab`,
        运营管理__站点配置__常见问题__页签查看: `questionQueryPerms`,
        运营管理__站点配置__常见问题__添加问题: `questionAddPerms`,
        运营管理__站点配置__常见问题__编辑: `questionEditPerms`,
        运营管理__站点配置__常见问题__删除: `questionDelPerms`,
        运营管理__会员分析: `merchantOperationManageMemberAnalysisTab`,
        运营管理__会员分析__出入款统计: `merchantOperationManageMemberAnalysisTabDepositWithdraw`,
        运营管理__会员分析__出入款统计__页签查看: `merchantOperationManageMemberAnalysisTabDepositWithdrawQueryPerm`,
        运营管理__会员分析__出入款统计__导出: `merchantOperationManageMemberAnalysisTabDepositWithdrawExportPerm`,
        运营管理__会员分析__优惠: `merchantOperationManageMemberAnalysisTabPromotion`,
        运营管理__会员分析__优惠__页签查看: `merchantOperationManageMemberAnalysisTabPromotionQueryPerm`,
        运营管理__会员分析__优惠__导出: `merchantOperationManageMemberAnalysisTabPromotionExportPerm`,
        运营管理__会员分析__下注分析: `merchantOperationManageMemberAnalysisTabBet`,
        运营管理__会员分析__下注分析__页签查看: `merchantOperationManageMemberAnalysisTabBetQueryPerm`,
        运营管理__会员分析__下注分析__导出: `merchantOperationManageMemberAnalysisTabBetExportPerm`,
        运营管理__会员分析__投注人数: `merchantOperationManageMemberAnalysisTabBettors`,
        运营管理__会员分析__投注人数__页签查看: `merchantOperationManageMemberAnalysisTabBettorsQueryPerm`,
        运营管理__会员分析__投注人数__导出: `merchantOperationManageMemberAnalysisTabBettorsExportPerm`,

        运营管理__注册与验证: `merchantOperationManageRegisterTab`,
        运营管理__注册与验证__注册配置: `merchantOperationManageRegisterTabRegister`,
        运营管理__注册与验证__注册配置__页面查看: `merchantOperationManageRegisterTabRegisterQueryPerm`,
        运营管理__注册与验证__注册配置__修改数据: `merchantOperationManageRegisterTabRegisterEditPerm`,
        运营管理__注册与验证__短信配置: `merchantOperationManageRegisterTabRegister`,
        运营管理__注册与验证__短信配置__页面查看: `merchantOperationManageRegisterTabRegisterQueryPerm`,
        运营管理__注册与验证__短信配置__新增数据: `merchantOperationManageRegisterTabMessageAddPerm`,
        运营管理__注册与验证__短信配置__修改数据: `merchantOperationManageRegisterTabRegisterEditPerm`,
        运营管理__注册与验证__短信配置__删除数据: `merchantOperationManageRegisterTabMessageDeletePerm`,
        运营管理__注册与验证__短信配置__禁用启用: `merchantOperationManageRegisterTabMessageStatusPerm`,
        运营管理__注册与验证__防刷风控: `merchantOperationManageRegisterTabRisk`,
        运营管理__注册与验证__防刷风控__页面查看: `merchantOperationManageRegisterTabRiskQueryPerm`,
        运营管理__注册与验证__防刷风控__修改数据: `merchantOperationManageRegisterTabRiskEditPerm`,
        运营管理__版本控制: `versionControl`,
        运营管理__版本控制__App更新: `appUpdateTab`,
        运营管理__版本控制__App更新__页签查看: `appUpdateQueryPerms`,
        运营管理__版本控制__App更新__新增版本: `appUpdateAddPerms`,
        运营管理__版本控制__App更新__状态开关: `appUpdateStatusPerms`,
        运营管理__版本控制__App更新__编辑: `appUpdateEditPerms`,
        运营管理__版本控制__离线包管理: `offlinePackageTab`,
        运营管理__版本控制__离线包管理__页签查看: `offlinePackageQueryPerms`,
        运营管理__版本控制__离线包管理__新增离线包地址: `offlinePackageAddPerms`,
        运营管理__版本控制__离线包管理__删除: `offlinePackageDelPerms`,
        运营管理__版本控制__离线包管理__状态开关: `offlinePackageStatusPerms`,
        // 优惠大改 建议重写
        优惠中心: `merchantPromotionManage`,
        优惠中心__活动中心: `merchantPromotionManageActivity`,
        优惠中心__活动中心__页签管理: `merchantPromotionManageActivity`,
        优惠中心__活动中心__页签管理__页签查看: `merchantPromotionManageActivityQueryPerm`,
        优惠中心__活动中心__页签管理__新增页签: `merchantPromotionManageActivityAddPerm`,
        优惠中心__活动中心__页签管理__删除: `merchantPromotionManageActivityDeletePerm`,
        优惠中心__活动中心__页签管理__编辑: `merchantPromotionManageActivityEditPerm`,
        优惠中心__活动中心__页签管理__状态开关: `merchantPromotionManageActivityStatusPerm`,
        优惠中心__活动中心__活动列表: `merchantPromotionManageEventTab`,
        优惠中心__活动中心__活动列表__活动查看: `merchantPromotionManageEventTabQueryPerm`,
        优惠中心__活动中心__活动列表__新增普通活动: `merchantPromotionManageEventTabAddPerm`,
        优惠中心__活动中心__活动列表__编辑: `merchantPromotionManageEventTabEditPerm`,
        优惠中心__活动中心__活动列表__删除: `merchantPromotionManageEventTabDeletePerm`,
        优惠中心__活动中心__活动列表__状态开关: `merchantPromotionManageEventTabStatusPerm`,
        优惠中心__任务管理: `taskSetting`,
        优惠中心__任务管理__页签管理: `taskTagManagementTab`,
        优惠中心__任务管理__页签管理__页签查看: `taskTagQueryPerms`,
        优惠中心__任务管理__页签管理__状态开关: `taskTagStatusPerms`,
        优惠中心__任务管理__页签管理__删除: `taskTagDelPerms`,
        优惠中心__任务管理__页签管理__编辑: `taskTagEditPerms`,
        优惠中心__任务管理__页签管理__新增页签: `merchantFinanceManagePaymentTabChannelAddPerm`,
        优惠中心__任务管理__任务管理: `taskSettingTab`,
        优惠中心__任务管理__任务管理__任务查看: `taskQueryPerms`,
        优惠中心__任务管理__任务管理__任务添加: `taskSettingAddPerms`,
        优惠中心__任务管理__任务管理__状态开关: `taskStatusPerms`,
        优惠中心__任务管理__任务管理__编辑: `taskEditPerms`,
        优惠中心__任务管理__任务管理__删除: `taskDelPerms`,
        优惠中心__任务管理__领取记录: `taskLogTab`,
        优惠中心__任务管理__领取记录__页签查看: `taskLogQueryPerms`,
        优惠中心__任务管理__领取记录__导出: `taskLogExportPerms`,
        优惠中心__预送彩金: `preBonus`,
        优惠中心__预送彩金__赠送彩金: `preBonusTab`,
        优惠中心__预送彩金__赠送彩金__页签查看: `preBonusQueryPerms`,
        优惠中心__预送彩金__赠送彩金__添加数据: `preBonusAddPerms`,
        优惠中心__预送彩金__赠送彩金__编辑: `preBonusEditPerms`,
        优惠中心__预送彩金__赠送彩金__发送: `preBonusDispatchPerms`,
        优惠中心__预送彩金__赠送记录: `preBonusLogTab`,
        优惠中心__预送彩金__赠送记录__页签查看: `preBonusLogQueryPerms`,
        优惠中心__预送彩金__赠送记录__导出: `preBonusLogExportPerms`,
        优惠中心__红包活动: `redPackageActivity`,
        优惠中心__红包活动__页面查看: `redPackageQueryPerms`,
        优惠中心__红包活动__发送包: `redPackageBonusPerms`,
        优惠中心__红包活动__关闭: `redPackageDelPerms`,
        优惠中心__红包活动__编辑: `redPackageEditPerms`,
        优惠中心__红包活动__补领: `redPackageReplacePerms`,
        优惠中心__红包活动__导出红包: `redPackageExportPerms`,
        优惠中心__签到活动: `signActivity`,
        优惠中心__签到活动__活动配置: `signSettingTab`,
        优惠中心__签到活动__活动配置__页签查看: `signSettingQueryPerms`,
        优惠中心__签到活动__活动配置__编辑: `signSettingEditPerms`,
        优惠中心__签到活动__领取记录: `signLogTab`,
        优惠中心__签到活动__领取记录__页签查看: `signLogQueryPerms`,
        优惠中心__签到活动__领取记录__导出: `signLogExportPerms`,
        优惠中心__盈利排行榜: `profitRanking`,
        优惠中心__盈利排行榜__活动配置: `profitRankingSettingTab`,
        优惠中心__盈利排行榜__活动配置__页签查看: `profitRankSettingQueryPerms`,
        优惠中心__盈利排行榜__活动配置__编辑: `profitRankingEditPerms`,
        优惠中心__盈利排行榜__盈利榜开关: `profitRankingStatusPerms`,
        优惠中心__盈利排行榜__机器人: `rankingRobotTab`,
        优惠中心__盈利排行榜__机器人__页签查看: `rankingRobotQueryPerms`,
        优惠中心__盈利排行榜__机器人__新增机器人: `rankingRobotAddPerms`,
        优惠中心__盈利排行榜__机器人__编辑: `rankingRobotEditPerms`,
        优惠中心__盈利排行榜__机器人__删除: `rankingRobotDelPerms`,
        优惠中心__盈利排行榜__机器人__状态开关: `rankingRobotStatusPerms`,
        优惠中心__盈利排行榜__排行榜: `profitRankingTab`,
        优惠中心__盈利排行榜__排行榜__页签查看: `profitRankingQueryPerms`,
        优惠中心__盈利排行榜__领取记录: `merchantPromotionManageActivityLog`,
        优惠中心__盈利排行榜__领取记录__页签查看: `merchantPromotionManageActivityLogQueryPerm`,
        优惠中心__盈利排行榜__领取记录__导出: `merchantPromotionManageActivityLogExportPerm`,
        优惠中心__返水设置: `cashBackSetting`,
        优惠中心__返水设置__返水设置: `cashBackTab`,
        优惠中心__返水设置__返水设置__页签查看: `cashBackQueryPerms`,
        优惠中心__返水设置__返水设置__新增设置: `cashBackAddPerms`,
        优惠中心__返水设置__返水设置__比例设置: `cashBackEditPerms`,
        优惠中心__返水设置__返水设置__状态开关: `cashBackStatusPerms`,
        优惠中心__返水设置__返水模板: `cashBackTemplateTab`,
        优惠中心__返水设置__返水模板__页签查看: `cashBackTemplateQueryPerms`,
        优惠中心__返水设置__返水模板__新增模板: `cashBackTemplateAddPerms`,
        优惠中心__返水设置__返水模板__编辑: `cashBackTemplateEditPerms`,
        优惠中心__返水设置__返水模板__删除: `cashBackTemplateDelPerms`,
        优惠中心__返水设置__返水记录: `cashBackLog`,
        优惠中心__返水设置__返水记录__页面查看: `cashBackLogQueryPerms`,
        // 代理大改，建议重写
        // 代理管理__代理后台账号: `agentUserQueryPerms`,
        // 代理管理: `merchantAgentManage`,
        // 代理管理__代理商查询: `agentQuery`,
        // 代理管理__代理商查询__页面查看: `agentQueryPerms`,
        // 代理管理__代理商查询__导出: `agentExportPerms`,
        // 代理管理__会员代理查询: `memberAgentQuery`,
        // 代理管理__会员代理查询__页面查看: `memberAgentQueryPerms`,
        // 代理管理__会员代理查询__导出: `merchantAgentManageAgentExportPerm`,
        // 代理管理__推广设置: `agentSetting`,
        // 代理管理__推广设置__基础设置: `agentCategoryTab`,
        // 代理管理__推广设置__基础设置__页签查看: `agentCategoryQueryPerms`,
        // 代理管理__推广设置__基础设置__绑定编辑_状态开关: `agentCategoryEditPerms`,
        // 代理管理__推广设置__推广设置: `agentSettingTab`,
        // 代理管理__推广设置__推广设置__页签查看: `agentSettingQueryPerms`,
        // 代理管理__推广设置__推广设置__提交: `agentSettingEditPerms`,
        // 代理管理__佣金记录: `rebateLog`,
        // 代理管理__佣金记录__页面查看: `rebateLogQueryPerms`,

        财务管理: `merchantFinanceManage`,
        财务管理__充值管理: `merchantFinanceManageDepositTab`,
        财务管理__充值管理__充值类型: `merchantFinanceManageDepositTabType`,
        财务管理__充值管理__充值类型__修改数据: `merchantFinanceManageDepositTabTypeEditPerm`,
        财务管理__充值管理__充值类型__禁用启用: `merchantFinanceManageDepositTabTypeStatusPerm`,
        财务管理__充值管理__三方通道: `merchantFinanceManageDepositTabChannel`,
        财务管理__充值管理__三方通道__新增数据: `merchantFinanceManageDepositTabChannelAddPerm`,
        财务管理__充值管理__三方通道__修改数据: `merchantFinanceManageDepositTabChannelEditPerm`,
        财务管理__充值管理__三方通道__删除数据: `merchantFinanceManageDepositTabChannelDeletePerm`,
        财务管理__充值管理__三方通道__禁用启用: `merchantFinanceManageDepositTabChannelStatusPerm`,
        财务管理__充值管理__三方统计: `merchantFinanceManageDepositTabStatistic`,
        财务管理__代付管理: `merchantFinanceManagePaymentTab`,
        财务管理__代付管理__代付通道: `merchantFinanceManagePaymentTabChannel`,
        财务管理__代付管理__代付通道__新增数据: `merchantFinanceManagePaymentTabChannelAddPerm`,
        财务管理__代付管理__代付通道__修改数据: `merchantFinanceManagePaymentTabChannelEditPerm`,
        财务管理__代付管理__代付通道__删除数据: `merchantFinanceManagePaymentTabChannelDeletePerm`,
        财务管理__代付管理__代付通道__禁用启用: `merchantFinanceManagePaymentTabChannelStatusPerm`,
        财务管理__代付管理__代付统计: `merchantFinanceManagePaymentTabStatistic`,
        财务管理__充提设置: `merchantFinanceManageWithdraw`,
        财务管理__充提设置__充值设置: `merchantFinanceManageWithdraw`,
        财务管理__充提设置__充值设置__提交: `merchantFinanceManageWithdraw`,
        财务管理__充提设置__提现设置: `merchantFinanceManageWithdraw`,
        财务管理__充提设置__提现设置__修改数据: `merchantFinanceManageWithdrawEditPerm`,
        财务管理__充提设置__提现设置__禁用启用: `merchantFinanceManageWithdrawStatusPerm`,

        财务管理__账户调整: `merchantFinanceManageAdjustmentTab`,
        财务管理__账户调整__账户调整: `merchantFinanceManageAdjustmentTabAdjustment`,
        财务管理__账户调整__账户调整__页签查看: `merchantFinanceManageAdjustmentTabAdjustmentAddPerm`,
        财务管理__账户调整__账户调整__提交: `merchantFinanceManageAdjustmentTabAdjustmentAddPerm`,
        财务管理__账户调整__审核列表: `merchantFinanceManageAdjustmentTabRecord`,
        财务管理__账户调整__审核列表__页签查看: `merchantFinanceManageAdjustmentTabRecordQueryPerm`,
        财务管理__账户调整__审核列表__锁定: `merchantFinanceManageAdjustmentTabRecordProceedPerm`,
        财务管理__账户调整__审核列表__审核权限: `merchantFinanceManageAdjustmentTabRecordProceedPerm`,
        财务管理__账户调整__历史记录: `merchantFinanceManageAdjustmentTabHistory`,
        财务管理__账户调整__历史记录__页签查看: `merchantFinanceManageAdjustmentTabHistoryQueryPerm`,
        财务管理__账户调整__历史记录__导出: `merchantFinanceManageAdjustmentTabHistoryQueryPerm`,
        财务管理__会员稽核: `merchantFinanceManageMemberAuditTab`,
        财务管理__会员稽核__稽核列表: `merchantFinanceManageMemberAuditTabMember`,
        财务管理__会员稽核__稽核列表__页签查看: `merchantFinanceManageMemberAuditTabMemberQueryPerm`,
        财务管理__会员稽核__稽核列表__人工清零: `merchantFinanceManageMemberAuditTabMemberClearPerm`,
        财务管理__会员稽核__稽核记录: `merchantFinanceManageMemberAuditTabLog`,
        财务管理__会员稽核__稽核记录__页签查看: `merchantFinanceManageMemberAuditTabLogQueryPerm`,
        财务管理__会员稽核__流水稽核设置: `merchantFinanceManageMemberAuditTabLogQueryPerm`,
        财务管理__会员稽核__流水稽核设置__页签查看: `merchantFinanceManageMemberAuditTabSettingQueryPerm`,
        财务管理__会员稽核__流水稽核设置__保存: `merchantFinanceManageMemberAuditTabSettingEditPerm`,
        // ?大改？
        财务管理__出入款审核: `merchantFinanceManageWithdrawReview`,
        财务管理__出入款审核__线上入款审核: `onlineFinanceApproveTab`,
        财务管理__出入款审核__线上入款审核__页签查看: `onlineFinanceApproveQueryPerms`,
        财务管理__出入款审核__线上入款审核__导出: `onlineFinanceApproveExportPerms`,
        财务管理__出入款审核__线上入款审核__审核权限: `onlineFinanceApprovePerms`,
        财务管理__出入款审核__线下入款审核: `offlineFinanceApproveTab`,
        财务管理__出入款审核__线下入款审核__页签查看: `offlineFinanceApproveQueryPerms`,
        财务管理__出入款审核__线下入款审核__导出: `offlineFinanceApproveExportPerms`,
        财务管理__出入款审核__线下入款审核__锁定: `offlineFinanceApproveLockPerms`,
        财务管理__出入款审核__出款审核: `withdrawApproveTab`,
        财务管理__出入款审核__出款审核__页签查看: `withdrawApproveQueryPerms`,
        财务管理__出入款审核__出款审核__锁定: `withdrawApproveLockPerms`,
        财务管理__出入款审核__出款审核__导出: `withdrawApproveExportPerms`,
        财务管理__出入款审核__出款审核__审核权限: `withdrawApprovePerms`,
        // 完成
        财务管理__出款设置: `merchantFinanceManageWithdraw`,
        财务管理__出款设置__页面查看: `merchantFinanceManageWithdrawQueryPerm`,
        财务管理__出款设置__新增出款设置模板: `merchantFinanceManageWithdrawEditPerm`,
        财务管理__出款设置__编辑: `merchantFinanceManageWithdrawEditPerm`,
        财务管理__出款设置__删除: `merchantFinanceManageWithdrawEditPerm`,
        财务管理__出款设置__状态开关: `merchantFinanceManageWithdrawStatusPerm`,
        // 大改？
        财务管理__提现信息配置: `withdrawConfigSetting`,
        财务管理__提现信息配置__虚拟币信息配置: `virtualCurrencySetting`,
        财务管理__提现信息配置__虚拟币信息配置__页签查看: `virtualSettingQueryPerms`,
        财务管理__提现信息配置__虚拟币信息配置__新增虚拟钱包: `virtualSettingAddPerms`,
        财务管理__提现信息配置__虚拟币信息配置__编辑: `virtualSettingEditPerms`,
        财务管理__提现信息配置__虚拟币信息配置__状态开关: `virtualSettingStatusPerms`,
        财务管理__提现信息配置__虚拟币信息配置__批量删除: `virtualSettingDelPerms`,
        财务管理__提现信息配置__银行卡信息配置: `bankCardSetting`,
        财务管理__提现信息配置__银行卡信息配置__页签查看: `bankCardSettingQueryPerms`,
        财务管理__提现信息配置__银行卡信息配置__新增银行信息: `bankCardSettingAddPerms`,
        财务管理__提现信息配置__银行卡信息配置__编辑: `bankCardSettingEditPerms`,
        财务管理__提现信息配置__银行卡信息配置__状态开关: `bankCardSettingStatusPerms`,
        财务管理__提现信息配置__银行卡信息配置__批量删除: `bankCardSettingDelPerms`,
        财务管理__活动彩金审核__页面查看: `merchantPromotionManageBonusReviewQueryPerm`,
        财务管理__活动彩金审核__编辑数据: `merchantPromotionManageBonusReviewProceedPerm`,
        财务管理__活动彩金审核__导出数据: `merchantPromotionManageBonusReviewExportPerm`,
        支付管理: `paymentManage`,
        支付配置: `paymentSetting`,
        风控管理: `riskManage`,
        风控管理__黑名单: `blackListSetting`,
        风控管理__黑名单__IP地址: `blackIpTab`,
        风控管理__黑名单__IP地址__页签查看: `blackIpQueryPerms`,
        风控管理__黑名单__IP地址__添加IP地址: `blackIpAddPerms`,
        风控管理__黑名单__IP地址__编辑: `blackIpEditPerms`,
        风控管理__黑名单__IP地址__删除: `blackIpDelPerms`,
        风控管理__黑名单__银行卡: `blackBankTab`,
        风控管理__黑名单__银行卡__页签查看: `blackBankQueryPerms`,
        风控管理__黑名单__银行卡__添加银行卡: `blackBankAddPerms`,
        风控管理__黑名单__银行卡__编辑: `blackBankEditPerms`,
        风控管理__黑名单__银行卡__删除: `blackBankDelPerms`,
        风控管理__黑名单__数字钱包: `blackWalletTab`,
        风控管理__黑名单__数字钱包__页签查看: `blackWalletQueryPerms`,
        风控管理__黑名单__数字钱包__添加钱包地址: `blackWalletAddPerms`,
        风控管理__黑名单__数字钱包__编辑: `blackWalletEditPerms`,
        风控管理__黑名单__数字钱包__删除: `blackWalletDelPerms`,
        风控管理__黑名单__返水: `blackAgentTab`,
        风控管理__黑名单__返水__页签查看: `blackAgentQueryPerms`,
        风控管理__黑名单__返水__添加会员账号: `blackAgentAddPerms`,
        风控管理__黑名单__返水__编辑: `blackAgentEditPerms`,
        风控管理__黑名单__返水__删除: `blackAgentDelPerms`,

        报表统计: `merchantReportManage`,
        报表统计__会员报表: `merchantReportManageMember`,
        报表统计__会员报表__页面查看: `merchantReportManageMemberQueryPerm`,
        报表统计__留存统计: `merchantReportManageRetentionTab`,
        报表统计__留存统计__新增留存: `merchantReportManageRetentionTabNew`,
        报表统计__留存统计__新增留存__页面查看: `merchantReportManageRetentionTabNewQueryPerm`,
        报表统计__留存统计__新增留存__导出: `merchantReportManageRetentionTabNewExportPerm`,
        报表统计__留存统计__充值留存: `merchantReportManageRetentionTabDeposit`,
        报表统计__留存统计__充值留存__页面查看: `merchantReportManageRetentionTabDepositQueryPerm`,
        报表统计__留存统计__充值留存__导出: `merchantReportManageRetentionTabDepositExportPerm`,
        报表统计__留存统计__投注留存: `merchantReportManageRetentionTabBet`,
        报表统计__留存统计__投注留存__页面查看: `merchantReportManageRetentionTabBetQueryPerm`,
        报表统计__留存统计__投注留存__导出: `merchantReportManageRetentionTabBetExportPerm`,
        报表统计__资金报表: `merchantReportManageFund`,
        报表统计__资金报表__页面查看: `merchantReportManageFundQueryPerm`,
        报表统计__资金报表__导出: `merchantReportManageFundExportPerm`,
        // ?
        报表统计__注册来源: `registerDomain`,
        报表统计__注册来源__页面查看: `registerDomainQueryPerms`,
        报表统计__注册来源__导出: `registerDomainExportPerms`,

        报表统计__游戏报表: `merchantReportManageGameTab`,
        报表统计__游戏报表__类型统计: `merchantReportManageGameTabType`,
        报表统计__游戏报表__类型统计__页面查看: `merchantReportManageGameTabTypeQueryPerm`,
        报表统计__游戏报表__类型统计__导出: `merchantReportManageGameTabTypeExportPerm`,
        报表统计__游戏报表__场馆统计: `merchantReportManageGameTabVenue`,
        报表统计__游戏报表__场馆统计__页面查看: `merchantReportManageGameTabVenueQueryPerm`,
        报表统计__游戏报表__场馆统计__导出: `merchantReportManageGameTabVenueExportPerm`,
        报表统计__游戏报表__子游戏统计: `merchantReportManageGameTabSubGame`,
        报表统计__游戏报表__子游戏统计__页面查看: `merchantReportManageGameTabSubGameQueryPerm`,
        报表统计__游戏报表__子游戏统计__导出: `merchantReportManageGameTabSubGameExportPerm`,
        // ?
        报表统计__游戏报表__子游戏统计__游戏详情查看: `gameDetailListReportQueryPerms`,
        报表统计__游戏报表__子游戏统计__游戏详情导出: `gameDetailListReportExportPerms`,

        报表统计__日运营报表: `merchantReportManageDailyOperation`,
        报表统计__日运营报表__页面查看: `merchantReportManageDailyOperationQueryPerm`,
        报表统计__日运营报表__导出: `merchantReportManageDailyOperationExportPerm`,
        系统管理: `merchantSystemManage`,
        // 迁移
        系统管理__导出任务__页签查看: `merchantReportManageExportQueryPerm`,
        系统管理__导出任务__下载: `merchantReportManageExportDownloadPerm`,
        系统管理__导出任务__删除: `merchantReportManageExportQueryPerm`,

        系统管理__管理员: `merchantSystemManageUserTab`,
        系统管理__管理员__管理员账号: `merchantSystemManageUserTabAccount`,
        系统管理__管理员__管理员账号__页签查看: `merchantSystemManageUserTabAccountQueryPerm`,
        系统管理__管理员__管理员账号__状态开关: `merchantSystemManageUserTabAccountFrozenPerm`,
        系统管理__管理员__管理员账号__新增管理员: `merchantSystemManageUserTabAccountAddPerm`,
        系统管理__管理员__管理员账号__编辑: `merchantSystemManageUserTabAccountEditPerm`,
        系统管理__管理员__管理员账号__修改密码: `merchantSystemManageUserTabAccountEditPerm`,
        系统管理__管理员__管理员账号__批量删除: `merchantSystemManageUserTabAccountDeletePerm`,
        系统管理__管理员____角色管理: `merchantSystemManageUserTabRole`,
        系统管理__管理员____角色管理__页签查看: `merchantSystemManageUserTabRoleQueryPerm`,
        系统管理__管理员____角色管理__新增角色: `merchantSystemManageUserTabRoleAddPerm`,
        系统管理__管理员____角色管理__状态开关: `merchantSystemManageUserTabRoleEditPerm`,
        系统管理__管理员____角色管理__编辑: `merchantSystemManageUserTabRoleEditPerm`,
        // 删除？
        系统管理__系统设置: `systemSetting`,
        系统管理__系统设置__域名配置: `domainTab`,
        系统管理__系统设置__域名配置__页面查看: `domainQueryPerms`,
        系统管理__系统设置__域名配置__保存: `domainEditPerms`,
        系统管理__系统设置__系统维护: `maintenanceTab`,
        系统管理__系统设置__系统维护__页面查看: `maintenanceQueryPerms`,
        系统管理__系统设置__系统维护__编辑: `maintenanceEditPerms`,
        系统管理__系统设置__客服密钥管理: `customerServiceTab`,
        系统管理__系统设置__客服密钥管理__页面查看: `customerSecretQueryPerms`,
        系统管理__系统设置__客服密钥管理__编辑: `customerServiceEditPerms`,

        系统管理__日志管理: `merchantSystemManageLogTab`,
        系统管理__日志管理__管理员登录日志: `merchantSystemManageLogTabLogin`,
        系统管理__日志管理__管理员登录日志__页面查看: `merchantSystemManageLogTabLoginQueryPerm`,
        系统管理__日志管理__管理员登录日志__导出: `merchantSystemManageLogTabLoginQueryPerm`,
        系统管理__日志管理__管理员操作日志: `merchantSystemManageLogTabOperation`,
        系统管理__日志管理__管理员操作日志__页面查看: `merchantSystemManageLogTabOperationQueryPerm`,
        系统管理__日志管理__管理员操作日志__导出: `merchantSystemManageLogTabOperationQueryPerm`,
        // 下面重新对接了
        商户后台__集团管理__组织管理: `organizeManage`,
        商户后台__集团管理__组织管理__公司管理__页面查看: `organizationManageCompanyQueryPerm`,
        商户后台__集团管理__组织管理__公司管理__公司编辑: `organizationManageCompanyAddPerm`,
        商户后台__集团管理__组织管理__公司管理__冻结: `organizationManageCompanyFrozenPerm`,
        商户后台__集团管理__组织管理__公司管理__费率配置: `organizationManageCompanyRatePerm`,
        商户后台__集团管理__组织管理__公司管理__重置登录密码: `organizationManageCompanyResetPerm`,
        商户后台__集团管理__组织管理__站点管理__页面查看: `organizationManageMerchantQueryPerm`,
        商户后台__集团管理__组织管理__站点管理__新增修改站点: `organizationManageMerchantAddPerm`,
        商户后台__集团管理__组织管理__站点管理__冻结_维护: `organizationManageMerchantFrozenPerm`,
        商户后台__集团管理__组织管理__站点管理__费率配置: `organizationManageMerchantRatePerm`,
        商户后台__集团管理__组织管理__系统公告__页面查看: `organizationManageAnnouncementQueryPerm`,
        商户后台__集团管理__组织管理__系统公告__公告编辑: `organizationManageAnnouncementAddPerm`,
        商户后台__集团管理__组织管理__版本维护__页面查看: `organizationManageVersionQueryPerm`,
        商户后台__集团管理__组织管理__版本维护__离线包更新: `organizationManageVersionAddPerm`,
        商户后台__集团管理__组织管理__版本维护__APP包上传: `organizationManageVersionUploadPerm`,
        商户后台__集团管理__组织管理__站点资源: `organizationManageMerchantResource`,
        商户后台__集团管理__组织管理__站点资源__页面查看: `organizationManageMerchantResourceQueryPerm`,
        商户后台__集团管理__组织管理__站点资源__资源编辑: `organizationManageMerchantResourceEditPerm`,
        商户后台__集团管理__组织管理__主题模板: `organizationManageTheme`,
        商户后台__集团管理__组织管理__主题模板__批量删除: `organizationManageThemeDeletePerm`,
        商户后台__集团管理__组织管理__主题模板__新增站点: `organizationManageThemeAddPerm`,
        商户后台__集团管理__支付平台管理__三方平台: `organizationPaymentThirdParty`,
        商户后台__集团管理__支付平台管理__三方支付平台__页面查看: `organizationPaymentThirdPartyQueryPerm`,
        商户后台__集团管理__支付平台管理__三方支付平台__修改平台: `organizationPaymentThirdPartyEditPerm`,
        商户后台__集团管理__游戏管理__游戏管理: `organizationGameManage`,
        商户后台__集团管理__游戏管理__游戏管理__平台管理__页面查看: `organizationGameTabSubGameQueryPerm`,
        商户后台__集团管理__游戏管理__游戏管理__平台管理__修改平台: `organizationGameTabPlatformEditPerm`,
        商户后台__集团管理__游戏管理__游戏管理__平台管理__维护_启用平台: `organizationGameTabPlatformStatusPerm`,
        商户后台__集团管理__游戏管理__游戏管理__子游戏管理__页面查看: `organizationGameTabSubGameQueryPerm`,
        商户后台__集团管理__游戏管理__游戏管理__子游戏管理__新增游戏: `organizationGameTabSubGameAddPerm`,
        商户后台__集团管理__游戏管理__游戏管理__子游戏管理__维护_启用游戏: `organizationGameTabSubGameMaintenancePerm`,
        商户后台__集团管理__游戏管理__游戏管理__子游戏管理__开启_关闭游戏: `organizationGameTabSubGameStatusPerm`,
        商户后台__集团管理__游戏管理__游戏管理__类型管理__页面查看: `organizationGameTabTypeQueryPerm`,
        商户后台__集团管理__游戏管理__游戏管理__类型管理__类型编辑: `organizationGameTabTypeEditPerm`,
        商户后台__集团管理__注单管理: `organizationGameManualOrder`,
        商户后台__集团管理__注单管理__人工拉单__页面查看: `organizationGameManualOrderQueryPerm`,
        商户后台__集团管理__注单管理__人工拉单__人工拉取注单: `organizationGameManualOrderAddPerm`,
        商户后台__集团管理__注单管理__人工拉单__人工拉单取消: `organizationGameManualOrderCancelPerm`,
        商户后台__集团管理__报表统计: `organizationReportManage`,
        商户后台__集团管理__报表统计__盈亏报表__页面查看: `organizationReportProfitQueryPerm`,
        商户后台__集团管理__报表统计__盈亏报表__数据导出: `organizationReportProfitExportPerm`,
        商户后台__集团管理__报表统计__公司报表__页面查看: `organizationReportCompanyQueryPerm`,
        商户后台__集团管理__报表统计__公司报表__数据导出: `organizationReportCompanyExportPerm`,
        商户后台__集团管理__系统管理: `organizationSystemManage`,
        商户后台__集团管理__系统管理__账号权限__后台账号__页面查看: `organizationSystemAccountTabAccountQueryPerm`,
        商户后台__集团管理__系统管理__账号权限__后台账号__新增账号: `organizationSystemAccountTabAccountAddPerm`,
        商户后台__集团管理__系统管理__账号权限__后台账号__冻结账号: `organizationSystemAccountTabAccountFrozenPerm`,
        商户后台__集团管理__系统管理__账号权限__权限角色__页面查看: `organizationSystemAccountTabRolesQueryPerm`,
        商户后台__集团管理__系统管理__账号权限__权限角色__新增角色: `organizationSystemAccountTabRolesAddPerm`,
        商户后台__集团管理__系统管理__IP白名单__页面查看: `organizationSystemIpWhitelistQueryPerm`,
        商户后台__集团管理__系统管理__IP白名单__编辑白名单: `organizationSystemIpWhitelistAddPerm`,
        商户后台__集团管理__系统管理__后台日志: `organizationSystemLogTab`,
        商户后台__集团管理__系统管理__后台日志__操作日志页面查看: `organizationSystemLogTabOperationQueryPerm`,
        商户后台__集团管理__系统管理__后台日志__登录日志页面查看: `organizationSystemLogTabLoginQueryPerm`,
        商户后台__集团管理__支付管理: "organizationPaymentManage",
        商户后台__集团管理__支付管理__支付类型: "organizationPaymentType",
        商户后台__集团管理__支付管理__提现账号管理: "organizeWithdrawalPage",
        商户后台__集团管理__支付管理__提现账号管理__新增: "organizeBankCardAddPerm",
        商户后台__集团管理__支付管理__提现账号管理__编辑: "organizeBankCardEditPerm",
        商户后台__集团管理__支付管理__提现账号管理__删除: "organizeBankCardDeletePerm",
        商户后台__集团管理__支付管理__提现账号管理__银行卡: "organizeBankCardTab",
        商户后台__集团管理__支付管理__提现账号管理__银行卡__新增: "organizeBankCardAddPerm",
        商户后台__集团管理__支付管理__提现账号管理__银行卡__编辑: "organizeBankCardEditPerm",
        商户后台__集团管理__支付管理__提现账号管理__银行卡__删除: "organizeBankCardDeletePerm",
        商户后台__集团管理__三方对账: "organizationReportThirdParty",
        商户后台__集团管理__三方对账__三方对账: "organizationReportThirdPartyQueryPerm",
        商户后台__集团管理__三方对账__三方对账__数据导出: "organizationReportThirdPartyExportPerm",
        // 下面公司未对接
        商户后台__公司管理__公司管理: `companyManage`,
        商户后台__公司管理__公司管理__站点管理: `companyManageMerchant`,
        商户后台__公司管理__公司管理__站点管理__页面查看: `companyManageMerchantQueryPerm`,
        商户后台__公司管理__公司管理__站点管理__新增站点: `companyManageMerchantAddPerm`,
        商户后台__公司管理__公司管理__站点管理__维护_取消维护: `companyManageMerchantFrozenPerm`,
        商户后台__公司管理__公司管理__站点管理__费率配置: `companyManageMerchantRatePerm`,
        商户后台__公司管理__公司管理__系统公告: `companyManageAnnouncement`,
        商户后台__公司管理__公司管理__系统公告__页面查看: `companyManageAnnouncementQueryPerm`,
        商户后台__公司管理__公司管理__系统公告__公告编辑: `companyManageAnnouncementAddPerm`,
        商户后台__公司管理__报表统计: `companyReportManage`,
        商户后台__公司管理__报表统计__盈亏报表: `companyReportManageProfit`,
        商户后台__公司管理__报表统计__盈亏报表__页面查看: `companyReportManageProfitQueryPerm`,
        商户后台__公司管理__报表统计__盈亏报表__数据导出: `companyReportManageProfitExportPerm`,
        商户后台__公司管理__系统管理: `companySystemManage`,
        商户后台__公司管理__系统管理__账号权限: `companySystemManageAccountTab`,
        商户后台__公司管理__系统管理__账号权限__后台账号: `companySystemManageAccountTabAccount`,
        商户后台__公司管理__系统管理__账号权限__后台账号__页面查看: `companySystemManageAccountTabAccountQueryPerm`,
        商户后台__公司管理__系统管理__账号权限__后台账号__新增账号: `companySystemManageAccountTabAccountAddPerm`,
        商户后台__公司管理__系统管理__账号权限__后台账号__冻结账号: `companySystemManageAccountTabAccountFrozenPerm`,
        商户后台__公司管理__系统管理__账号权限__权限角色: `companySystemManageAccountTabRole`,
        商户后台__公司管理__系统管理__账号权限__权限角色__页面查看: `companySystemManageAccountTabAccountQueryPerm`,
        商户后台__公司管理__系统管理__账号权限__权限角色__新增角色: `companySystemManageAccountTabRoleAddPerm`,
        商户后台__公司管理__系统管理__IP白名单: `companySystemManageIpWhitelist`,
        商户后台__公司管理__系统管理__IP白名单__页面查看: `companySystemManageIpWhitelistQueryPerm`,
        商户后台__公司管理__系统管理__IP白名单__新增白名单: `companySystemManageIpWhitelistAddPerm`,
        商户后台__公司管理__系统管理__后台日志: `companySystemManageLogTab`,
        商户后台__公司管理__系统管理__后台日志__操作日志页面查看: `companySystemManageLogTabOperation`,
        商户后台__公司管理__系统管理__后台日志__登录日志页面查看: `companySystemManageLogTabLogin`,
    },
}

export default globalEnumPermData
